import React, { useRef, useEffect } from 'react';
import ThreeBackground from './ThreeBackground';
import './Hero.css';

const TITLE_LINES = ['BAD ART', 'GETS BETTER.'];

export default function Hero() {
  const lineRefs = useRef([]);

  // Simple stagger entrance
  useEffect(() => {
    lineRefs.current.forEach((el, i) => {
      if (!el) return;
      el.style.transitionDelay = `${0.15 + i * 0.18}s`;
      el.classList.add('hero-line--in');
    });
  }, []);

  const scrollToWork = () => {
    const el = document.getElementById('portfolio');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" aria-label="Introduction">
      {/* Three.js particle canvas */}
      <ThreeBackground />

      {/* Vignette */}
      <div className="hero-vignette" aria-hidden="true" />

      <div className="hero-inner">
        {/* Main statement */}
        <h1 className="hero-headline" aria-label={TITLE_LINES.join(' ')}>
          {TITLE_LINES.map((line, i) => (
            <span
              key={i}
              ref={el => lineRefs.current[i] = el}
              className="hero-line"
            >
              {line}
            </span>
          ))}
        </h1>

        {/* Subline */}
        <p className="hero-sub">
          Two years of drawing every day.&nbsp;&nbsp;Watch it happen.
        </p>

        {/* CTA */}
        <div className="hero-ctas">
          <button className="hero-btn hero-btn--primary" onClick={scrollToWork}>
            See the work <span className="hero-btn-arrow">↓</span>
          </button>
          <a
            className="hero-btn hero-btn--secondary"
            href="https://www.instagram.com/knowndisc/"
            target="_blank" rel="noopener noreferrer"
          >
            Instagram
          </a>
        </div>

        {/* Corner label */}
        <div className="hero-corner-label" aria-hidden="true">
          <span>Digital Artist</span>
          <span className="hero-corner-year">© {new Date().getFullYear()}</span>
        </div>

        {/* Crosshair decoration (reference image inspired) */}
        <div className="hero-crosshair" aria-hidden="true">
          <div className="hero-crosshair-h" />
          <div className="hero-crosshair-v" />
          <div className="hero-crosshair-circle" />
        </div>
      </div>

      {/* Scroll hint */}
      <button className="hero-scroll-hint" onClick={scrollToWork} aria-label="Scroll to work">
        <span className="scroll-line" />
        <span className="scroll-label">scroll</span>
      </button>
    </section>
  );
}
